/**
 * Mock data based on the Excel sample provided
 * This simulates the "Consol Revenue register" sheet data
 */

import { ExcelColumn, ExcelData } from "./types";

// Mock Excel data structure
export const mockExcelData: ExcelData = {
  headers: [
    "Location",
    "CY_Sen",
    "MS/N",
    "Invoice N",
    "Inv Date",
    "Name of the Client",
    "Geograp",
    "Direct/In",
    "Revenue",
    "Segment",
    "Sub-Segr",
    "Billing Ty",
    "Project N",
    "Internal",
    "Sales cha",
    "Service Mo",
    "Payroll c",
    "EMP ID",
    "EMP Nan",
    "Adj. hou",
    "Inv Value (Gross)",
    "Discou",
  ],
  rows: [
    [
      "India",
      "CY24",
      "NA",
      "1432/24-25",
      "02-Jan-25",
      "Apollo Hospitals Enterprise Ltd",
      "Domestic",
      "Direct",
      "Managed se",
      "Cloud & da",
      "Cloud & dat",
      "Fixed biling",
      "NA",
      "NA",
      "Direct Sales",
      "Dec-24",
      "In Payroll (",
      "QR-1338",
      "Debes Dash",
      168,
      300000,
      0,
    ],
    [
      "India",
      "CY24",
      "NA",
      "1432/24-25",
      "02-Jan-25",
      "Apollo Hospitals Enterprise Ltd",
      "Domestic",
      "Direct",
      "Managed se",
      "Cloud & da",
      "Cloud & dat",
      "Fixed biling",
      "NA",
      "NA",
      "Direct Sales",
      "Dec-24",
      "In Payroll (",
      "QR-1613",
      "Balaji Panar",
      175,
      275000,
      0,
    ],
    [
      "India",
      "CY24",
      "NA",
      "1433/24-25",
      "06-Jan-25",
      "Apollo Hospitals Enterprise Ltd",
      "Domestic",
      "Direct",
      "Managed se",
      "Cloud & da",
      "Data analyti Time and m",
      "Fixed biling",
      "NA",
      "NA",
      "Direct Sales",
      "Dec-24",
      "In Payroll (",
      "QR-2133",
      "Suvitha",
      152,
      90476,
      0,
    ],
    [
      "India",
      "CY24",
      "NA",
      "1435/24-25",
      "07-Jan-25",
      "Apollo Hospitals Enterprise Ltd",
      "Domestic-SE",
      "Indirect",
      "Managed se",
      "Next-gen",
      "AI/ML & Au",
      "Fixed biling",
      "NA",
      "NA",
      "Al Conferer",
      "Dec-24",
      "In Payroll (",
      "QR-1338",
      "Debes Dash",
      120,
      210000,
      0,
    ],
    [
      "India",
      "CY24",
      "NA",
      "1436/24-25",
      "07-Jan-25",
      "Hexaware Technologies Ltd",
      "Domestic",
      "Direct",
      "Managed se",
      "Cloud & da",
      "Cloud & dat",
      "Fixed biling",
      "NA",
      "NA",
      "Direct Sales",
      "Dec-24",
      "In Payroll (",
      "QR-1613",
      "Balaji Panar",
      160,
      250000,
      0,
    ],
    [
      "India",
      "CY24",
      "NA",
      "1437/24-25",
      "08-Jan-25",
      "NEULAND LABORATORIES LIMITED",
      "Domestic",
      "Direct",
      "Managed se",
      "Cloud & da",
      "Data analyti Time and m",
      "Fixed biling",
      "NA",
      "NA",
      "Direct Sales",
      "Dec-24",
      "In Payroll (",
      "QR-2133",
      "Suvitha",
      140,
      180000,
      0,
    ],
    [
      "India",
      "CY24",
      "NA",
      "1438/24-25",
      "09-Jan-25",
      "Apollo Hospitals Enterprise Ltd",
      "Domestic",
      "Direct",
      "Managed se",
      "Next-gen",
      "AI/ML & Au",
      "Fixed biling",
      "NA",
      "NA",
      "Direct Sales",
      "Dec-24",
      "In Payroll (",
      "QR-1338",
      "Debes Dash",
      175,
      320000,
      0,
    ],
    [
      "India",
      "CY24",
      "NA",
      "1439/24-25",
      "10-Jan-25",
      "Hexaware Technologies Ltd",
      "Domestic-SE",
      "Indirect",
      "Managed se",
      "Cloud & da",
      "Cloud & dat",
      "Fixed biling",
      "NA",
      "NA",
      "Al Conferer",
      "Dec-24",
      "In Payroll (",
      "QR-1613",
      "Balaji Panar",
      168,
      280000,
      0,
    ],
  ],
};

// Generate categorized columns from mock data
export const mockColumns: ExcelColumn[] = [
  // Dimensions (Strings/Dates)
  {
    id: "location",
    name: "Location",
    type: "string",
    category: "dimension",
    index: 0,
  },
  {
    id: "cy_sen",
    name: "CY_Sen",
    type: "string",
    category: "dimension",
    index: 1,
  },
  {
    id: "inv_date",
    name: "Inv Date",
    type: "date",
    category: "dimension",
    index: 4,
  },
  {
    id: "name_of_client",
    name: "Name of the Client",
    type: "string",
    category: "dimension",
    index: 5,
  },
  {
    id: "geograp",
    name: "Geograp",
    type: "string",
    category: "dimension",
    index: 6,
  },
  {
    id: "direct_in",
    name: "Direct/In",
    type: "string",
    category: "dimension",
    index: 7,
  },
  {
    id: "segment",
    name: "Segment",
    type: "string",
    category: "dimension",
    index: 9,
  },
  {
    id: "sub_segr",
    name: "Sub-Segr",
    type: "string",
    category: "dimension",
    index: 10,
  },
  {
    id: "emp_nan",
    name: "EMP Nan",
    type: "string",
    category: "dimension",
    index: 18,
  },
  // Metrics (Numbers)
  {
    id: "adj_hou",
    name: "Adj. hou",
    type: "number",
    category: "metric",
    index: 19,
  },
  {
    id: "inv_value_gross",
    name: "Inv Value (Gross)",
    type: "number",
    category: "metric",
    index: 20,
  },
];

export const mockDimensions = mockColumns.filter((c) => c.category === "dimension");
export const mockMetrics = mockColumns.filter((c) => c.category === "metric");

